module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_e_Workshop_Cybersecurity_com_Solucoes_Open_Source.dc07f896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Mobile_Carrosel_e_Workshop_Cybersecurity_com_Solucoes_Open_Source.png
// module id = 55
// module chunks = 0